module.exports = __webpack_public_path__ + "static/media/grimace.145449c3.svg";